export default "__VITE_ASSET__eHXa3rxI__"